import type { QueryClient } from "@tanstack/react-query";

/**
 * Refetch everything an appointment change can affect: the calendar and client lists, free time, and sales (notes
 * on a completed visit).
 */
export function invalidateAppointmentQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ["appointments"] });
  queryClient.invalidateQueries({ queryKey: ["appointments-availability"] });
  queryClient.invalidateQueries({ queryKey: ["sales"] });
}
